import { NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewChild, HostListener, Input } from '@angular/core';
import { LocationService } from 'src/app/core/services/location.service';
import { select, Store } from "@ngrx/store";
import { take, takeUntil } from "rxjs/operators";
import { EmptyPaginator, PaginatorModel } from "../../../../shared/interfaces/PaginatorModel";
import { Subject } from "rxjs";
import { Helper } from "../../../../shared/services/Helper.service";
import { CreateVisitor } from 'src/app/states/auth/auth.actions';
import { IItem } from 'src/app/shared/interfaces/iitem';
import { SessionService } from "../../../../shared/services/session.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationModal } from 'src/app/shared/components/dialog/dialog.component';
import { DisLikeItem, ItemPostCommentReset, LikeItem } from 'src/app/states/Item/item.actions';
import { CommentDialogComponent } from '../../store-detail/item-tile/comment-dialog/comment-dialog.component';
import { ItemSelector } from 'src/app/states/Item/item.selectors';
import { ItemService } from 'src/app/home/services/item.service';

@Component({
    selector: 'app-item-list',
    templateUrl: './item-list.component.html',
    styleUrls: ['./item-list.component.scss'],
})
export class ItemListComponent implements OnInit, OnDestroy {
    @Input() item: IItem;
    @Input() IsWishList: boolean
    public isItemOutOfStock: any
    constructor(
        private router: Router,
        private locationService: LocationService,
        private store: Store,
        private helper: Helper,
        private sessionService: SessionService,
        private dialog: MatDialog,
        private itemService: ItemService,
    ) {
    }

    public isLike: boolean = false
    public isReview: boolean = false

    ngOnInit(): void {
        const like = this.item?.likes.find(like => like.accessId?.id === this.sessionService.state?.profile?.id)
        if (like) {
            this.isLike = true
        }

        const review = this.item?.review.find(review => review.accessId?.id === this.sessionService.state?.profile?.id)
        if (review) {
            this.isReview = true
        }

    }

    get image(): string {
        if (!this.item?.images?.length) {
            return '';
        }
        const showOnListingImage = this.item.images.find(img => img.showOnListing === true);
        return (showOnListingImage && showOnListingImage.ITEM_LISTING) ? showOnListingImage.ITEM_LISTING.s3url : this.item.images[0].ITEM_LISTING.s3url;
        // return (this.item?.images?.length) ? this.item?.images[0]?.ITEM_LISTING?.s3url : '';
    }

    getPrice(item: IItem): number[] {
        const prices = [item?.discountedPrice, item?.price].filter(price => price !== undefined);

        if (prices.length > 1 && prices[0] === prices[1]) {
            return [prices[0]];
        }
        return prices;
    }

    ngOnDestroy(): void {
    }


    public redirect($event: MouseEvent, item: IItem) {
        $event.stopPropagation();
        this.router.navigate(['/item', item?.uniqueName])
        // .then(() => {
        // window.location.reload();
        // });
    }

    public doLike($event: MouseEvent, item: IItem) {
        ;
        $event.stopPropagation();
        if (this.sessionService?.state && this.sessionService?.state?.token) {
            if (item.likes && item.likes.length) {
                const like = item?.likes.find(like => like.accessId?.id === this.sessionService.state?.profile?.id)
                if (like) {
                    this.store.dispatch(
                        new DisLikeItem({
                            itemId: item?.id,
                            likeId: like?.id
                        })
                    );
                    this.isLike = false
                } else {
                    this.store.dispatch(
                        new LikeItem({
                            itemId: item?.id
                        })
                    );
                    this.isLike = true
                }
            } else {
                this.store.dispatch(new LikeItem({
                    itemId: item?.id
                }));
                this.isLike = true
            }
        } else {
            this.askForLogin();
        }
    }


    private askForLogin() {
        const dialog = this.dialog.open(ConfirmationModal, {
            width: 'auto',
            data: {
                dialogTitle: 'Login',
                dialogMessage: 'To perform this action you need to login',
                dailogCancelBtnTitle: 'Cancel',
                dailogSuccessBtnTitle: 'Continue',
                params: true,
            }
        });

        dialog.componentInstance.onSuccessEvent.subscribe(res => {
            this.dialog.closeAll();
            this.router.navigate(['login']);
        });
    }


    public doComment($event: MouseEvent, item: IItem) {
        $event.stopPropagation();
        if (this.sessionService?.state && this.sessionService?.state?.token) {
            const commentDialog = this.dialog.open(CommentDialogComponent, {
                width: '350px',
                hasBackdrop: true,
                data: {
                    itemId: item?.id,
                }
            });

            this.subscribeToPostCommentResponse();
        } else {
            this.askForLogin();
        }
    }

    private subscribeToPostCommentResponse() {
        this.store.select(ItemSelector.selectPostCommentResponse).subscribe(ItemPostCommentResponse => {
            if (ItemPostCommentResponse) {
                this.dialog.closeAll();
                this.isReview = true
                this.store.dispatch(new ItemPostCommentReset());
            } else {
                this.isReview = false
            }
        });
    }

    public addRemoveCompareItem($event: any, item: IItem) {
        if ($event) {
            this.itemService.AddItemToCompare(item);
        } else {
            this.itemService.RemoveItemFromCompare(item);
        }
    }

    public isItemIncludedInCompareList(item: IItem): boolean {
        return this.itemService.hasItemInCompareList(item)
    }

}
